import script from "./SelectService.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectService.vue?vue&type=script&setup=true&lang=js"

import "./SelectService.vue?vue&type=style&index=0&id=2d4b1258&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\MXRover\\mxrover_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d4b1258"]])

export default __exports__